module.exports = __webpack_public_path__ + "img/trash.65cee7c8.svg";